import React, { useState } from 'react';
import { Eye, X } from 'lucide-react';

import PortalLayout from '../../components/layout/PortalLayout';
import ClientDashboard from '../portal/ClientDashboard';
import ClientProfile from '../portal/ClientProfile';
import PortalCaso from '../portal/PortalCaso';
import PortalFinanceiro from '../portal/PortalFinanceiro';
import PortalAcademia from '../portal/PortalAcademia';
import PortalVault from '../portal/PortalVault';

const TAB_MAP = {
  dashboard: ClientDashboard,
  caso: PortalCaso,
  perfil: ClientProfile,
  financeiro: PortalFinanceiro,
  academia: PortalAcademia,
  vault: PortalVault,
};

export default function PortalPreviewPage({ clientId, clientName, onClose }) {
  const [activeKey, setActiveKey] = useState('caso');

  const ActiveComponent = TAB_MAP[activeKey] || PortalCaso;

  const handlePortalNavigate = (key) => {
    setActiveKey(key);
  };

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col bg-white overflow-hidden">
      {/* Banner MODO PREVIEW */}
      <div className="shrink-0 flex items-center justify-between px-4 py-2 bg-amber-400 text-amber-900">
        <div className="flex items-center gap-2">
          <Eye className="w-4 h-4 shrink-0" />
          <span className="text-xs font-extrabold uppercase tracking-widest">
            MODO PREVIEW ADMIN
          </span>
          <span className="text-xs font-bold">
            — visualizando como: <span className="font-extrabold">{clientName || clientId}</span>
          </span>
          <span className="text-[10px] text-amber-800 ml-2">
            Nenhuma ação aqui afeta dados reais do cliente
          </span>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="flex items-center gap-1 px-3 py-1 rounded-lg bg-amber-600 text-white text-xs font-bold hover:bg-amber-700 transition-colors"
        >
          <X className="w-3.5 h-3.5" />
          Fechar Preview
        </button>
      </div>

      {/* Portal renderizado com o contexto do cliente forçado */}
      <div className="flex-1 min-h-0 overflow-hidden">
        <PortalLayout activeKey={activeKey} onNavigate={handlePortalNavigate} forcedClientId={clientId}>
          <ActiveComponent />
        </PortalLayout>
      </div>
    </div>
  );
}
